function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/FIGURES/legend-eau-surface-intrmt");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/FIGURES/legend-eau-surface-intrmt"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.9395051,1.99933047 L27.9995051,2.05833047 L27.9995051,3.41433047 L3.41450506,27.9993305 L2,28 L1.99950506,26.5863305 L26.5855051,1.99933047 L27.9395051,1.99933047 Z M27.9995051,6.58433047 L27.9995051,9.41433047 L9.41450506,27.9993305 L6.58550506,27.9993305 L27.9995051,6.58433047 Z M27.9995051,12.5843305 L27.9995051,15.4143305 L15.4145051,27.9993305 L12.5855051,27.9993305 L27.9995051,12.5843305 Z M27.9995051,18.5843305 L27.9995051,21.4143305 L21.4145051,27.9993305 L18.5855051,27.9993305 L27.9995051,18.5843305 Z M23.4155051,1.99933047 L1.99950506,23.4153305 L1.99950506,20.5863305 L20.5855051,1.99933047 L23.4155051,1.99933047 Z M17.4155051,1.99933047 L1.99950506,17.4153305 L1.99950506,14.5863305 L14.5855051,1.99933047 L17.4155051,1.99933047 Z M11.4155051,1.99933047 L1.99950506,11.4153305 L1.99950506,8.58633047 L8.58550506,1.99933047 L11.4155051,1.99933047 Z",
  id: "Combined-Shape",
  fill: "#80D5FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9,21 L9,28 L2,28 L2,21 L9,21 Z M28,21 L28,28 L21,28 L21,21 L28,21 Z M9,11 L9,19 L2,19 L2,11 L9,11 Z M19,21 L19,28 L11,28 L11,21 L19,21 Z M19,2 L19,9 L11,9 L11,2 L19,2 Z M28,11 L28,19 L21,19 L21,11 L28,11 Z M9,2 L9,9 L2,9 L2,2 L9,2 Z M28,2 L28,9 L21,9 L21,2 L28,2 Z",
  id: "Shape",
  fill: "#5990FF",
  fillRule: "nonzero"
})));

const SvgIco30EauSurfaceIntrmt = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30EauSurfaceIntrmt, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-eauSurfaceIntrmt.80bb2072.svg";
export { ForwardRef as ReactComponent };